// BonBoZ: huy hiệu số đỏ trên icon app khi đã cài dashboard ra màn hình chính.
//
// Chatwoot không hề gọi Badging API ở đâu, nên PWA không bao giờ có số đỏ dù
// thông báo đẩy chạy tốt. Trên điện thoại đó là thứ nhân viên liếc thấy đầu
// tiên, trước cả khi mở máy.
//
// Hai chỗ cùng cập nhật huy hiệu, cố ý:
//   - `public/sw.js` khi có thông báo đẩy tới, lúc app đã đóng. Số do server
//     đếm sẵn và gửi kèm, vì service worker không hỏi API được.
//   - chỗ này, mỗi lần số chưa đọc trong trang đổi. Nó ghi đè số của server nên
//     đọc thông báo ở máy tính là huy hiệu trên điện thoại cũng đúng lại ngay
//     lần mở app sau.
//
// Điều kiện của Apple: chỉ chạy với web app đã thêm vào màn hình chính, và
// người dùng phải đã cấp quyền thông báo. Trong tab trình duyệt thường thì hàm
// không tồn tại — nên kiểm tra rồi im lặng bỏ qua, đây không phải lỗi.

export const updateAppBadge = count => {
  if (!('setAppBadge' in navigator)) return;

  const unreadCount = Number(count);

  try {
    if (!Number.isFinite(unreadCount) || unreadCount <= 0) {
      navigator.clearAppBadge();
    } else {
      navigator.setAppBadge(unreadCount);
    }
  } catch (error) {
    // Một số trình duyệt ném lỗi khi chưa có quyền thông báo. Huy hiệu là thứ
    // trang trí, hỏng thì bỏ qua chứ không được làm gãy luồng đang chạy.
  }
};
